import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import elakayEmptyBox from "../Layout/icon/elakayEmptyBox.png";
import ShowimagesLoading from '../pageInside/showImagesLoading';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-cards';

import './swiperEffertCards.css';

import useElakaySwiper from "./swiperSettings/useElakaySwiper";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["swiperEffectCards"]?.[key] || fallback;

const SwiperEffectCards = (props)=>{
  const {
    pathUrl,
graphicImgBs,
el = false,
infoSource,
swiperOptions
  } = props
  __setElakayInfoSource(infoSource);
  // Options: page instance > Animation Settings -> Swiper Settings > origin
  // (origin = the "cards" effect this component was built for).
  const swp = useElakaySwiper("cardsStack", { swiperOptions, slideCount: graphicImgBs?.length || 0 });

      return (
    <>
      <Swiper
        key={swp.key}
        {...swp.swiperProps}
        className={`mySwiper swiper_effectCard ${swp.className}`}
        style={swp.style}
      >
      {graphicImgBs?.map((msg, index)=>{
        let i =  el? msg : index
       return <SwiperSlide key={index}>
            <ShowimagesLoading
                                                  className="card-img-top"
                                                  src={pathUrl+"?i="+ i}
                                                  alt={__elakayText("t001", "Fallback image")}
                                                  style={{ height: "100%", width: "100%" }}
                                                  onError={(event) => {
                                                    event.target.style.display = "none";
                                                  }}
                                                />
        </SwiperSlide>
 })}
       
      </Swiper>
    </>
  );

}
export default  SwiperEffectCards;